<template>
<div>
  <div class="card card-custom gutter-b rounded">


    <v-carousel
        class="rounded"
        cycle
        height="auto"
        carousel-dot-margin="1 20px"
        hide-delimiter-background
        vertical
        show-arrows-on-hover
        :show-arrows="false"
        vertical-delimiters="vertical"
    >
      <a href="#"  v-for="(slide, i) in banners" :key="i" @click="openUrl(slide.link, $event)"  >
      <v-carousel-item

          :src="coreUrl(slide.picture)"
      >
      </v-carousel-item
          >
      </a>
    </v-carousel>
  </div>

</div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      banners: []
    }
  },

  created() {
    this.getBanner();
    // setTimeout(() => {
    //   const next = document.querySelector('.v-window__next');
    //   const prev = document.querySelector('.v-window__prev');
    //   next.classList.add('d-none')
    //   prev.classList.add('d-none')
    //   next.classList.add('d-md-block')
    //   prev.classList.add('d-md-block')
    // },1000)

  },

  methods: {
    openUrl(link, e) {
      e.preventDefault()
      window.open(link, '_blank')
    },
    getBanner() {
      this.requestApiGet('contentIndex?type=banner')
          .then(({data}) => {
            this.banners = data.data
          }).catch(({response}) => {

      })
    },
    coreUrl(url) {
      return this.$sarveLand + `/${url}`;
    }
  }
}
</script>

<style scoped>
.v-carousel__controls  {
  left: -47% !important;
  max-height: 5px;
  margin-bottom: 11%;
  transform: rotate(270deg)!important;
  justify-content: center;
}
.v-window__next{
  left:55% !important;
  transform: rotate(270deg)!important;
  bottom: -43% !important;

}
.v-window__prev {
  right:50.6% !important;

  transform: rotate(270deg)!important;
  top: 0% !important;
}
</style>